import { ApiResponse } from 'apisauce';
import {
  GlobalSearchParams,
  GlobalSearchResponse,
} from '../../../modules/global-search/globalSearch.types';
import { cancelTokenFromSignal } from '../../../utils/axios.utils';
import { restApi } from '../../api';
import { serializeEntityTypes } from './globalSearch.serializers';

const PATH = '/global-search';

export const findGlobalSearch = (
  params: GlobalSearchParams,
  signal?: AbortSignal,
): Promise<ApiResponse<GlobalSearchResponse>> =>
  restApi.get<GlobalSearchResponse>(
    PATH,
    {
      q: params.q,
      entityTypes: serializeEntityTypes(params.entityTypes),
      skip: params.skip,
      limit: params.limit,
    },
    { cancelToken: cancelTokenFromSignal(signal)?.token },
  );
